import { render, staticRenderFns } from "./novaPropostaVida.vue?vue&type=template&id=77638380&scoped=true"
import script from "./novaPropostaVida.vue?vue&type=script&lang=js"
export * from "./novaPropostaVida.vue?vue&type=script&lang=js"
import style0 from "./novaPropostaVida.vue?vue&type=style&index=0&id=77638380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77638380",
  null
  
)

export default component.exports